var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bind-supplier" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "供应商绑定",
            visible: _vm.dialogFormVisible,
            modal: false,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogFormVisible = $event
            },
            close: _vm.close,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, "label-width": "120px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "权重排序：" } },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.form.weight,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "weight", _vm._n($$v))
                      },
                      expression: "form.weight",
                    },
                  }),
                  _vm._v(" "),
                  _c("span", [_vm._v("取值范围0-99，数值越小越靠前")]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "供货商家：" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: { placeholder: "请选择" },
                      on: { change: _vm.selectSupplier },
                      model: {
                        value: _vm.form.supplierId,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "supplierId", $$v)
                        },
                        expression: "form.supplierId",
                      },
                    },
                    _vm._l(_vm.suppliers, function (opt) {
                      return _c("el-option", {
                        key: opt.id,
                        attrs: { label: opt.supplierName, value: opt.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "增加导入商品：" } },
                [
                  _c("UploadExcel", {
                    staticClass: "upload-excel",
                    attrs: { onSuccess: _vm.onSuccess },
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v("支持扩展名：.xlsx .csv")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "表格格式：商品编码、价格形式、对应值，如导入文件中有供应商对应商品则选中。"
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "供货商品：" } },
                [
                  _c(
                    "el-table",
                    {
                      ref: "tableRef",
                      attrs: { data: _vm.tableData.list },
                      on: { "selection-change": _vm.handleSelectionChange },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { type: "selection", width: "55" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "productCode", label: "商品编码" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "productName", label: "商品名称" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "faceValue", label: "面值" },
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "priceType", label: "价格形式" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c(
                                  "el-radio-group",
                                  {
                                    model: {
                                      value: scope.row.priceType,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "priceType", $$v)
                                      },
                                      expression: "scope.row.priceType",
                                    },
                                  },
                                  _vm._l(_vm.priceEnum, function (rad) {
                                    return _c(
                                      "el-radio",
                                      {
                                        key: rad.value,
                                        attrs: { label: rad.value },
                                      },
                                      [_vm._v(_vm._s(rad.label))]
                                    )
                                  }),
                                  1
                                ),
                              ]
                            },
                          },
                        ]),
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { prop: "value", label: "值", width: "100" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("el-input", {
                                  model: {
                                    value: scope.row.value,
                                    callback: function ($$v) {
                                      _vm.$set(scope.row, "value", $$v)
                                    },
                                    expression: "scope.row.value",
                                  },
                                }),
                              ]
                            },
                          },
                        ]),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "buttons" },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v("保存")]
              ),
              _vm._v(" "),
              _c("el-button", { on: { click: _vm.close } }, [_vm._v("取消")]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }